package api

sealed class CurrencyType(val mask: Int, val key: String, var symbol: String = key) {


    data object UNDEFINED : CurrencyType(1, "UNDEFINED")
    data object EUR : CurrencyType(2, "EUR", "€")
    data object USD : CurrencyType(4, "USD", "\$")
    data object CZK : CurrencyType(8, "CZK", "CZK")
    data object BAM : CurrencyType(16, "BAM", "KM")

    infix fun match(mask: Int): Boolean = this.mask and mask > 0

    companion object {
        val all by lazy {
            listOf(
                UNDEFINED,
                EUR,
                USD,
                CZK,
                BAM
            )
        }

        operator fun get(type: Int): CurrencyType {
            return all.firstOrNull { it match type } ?: UNDEFINED
        }

        operator fun get(key: String): CurrencyType {
            return all.firstOrNull { it.key == key.uppercase() } ?: UNDEFINED
        }
    }
}
